import { NgbDateParserFormatter, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { isNumber } from 'util';

export class NgbDateOLParserFormatter extends NgbDateParserFormatter {
	parse(value: string): NgbDateStruct {
		if (value) {
			const dateParts = value.trim().split('-');
			return null;
		}
	}

	format(date: NgbDate): string {
		return date ?
			`${date.year}/${date.month}/${date.day}` :
			null;
	}

	formatForServer(date: NgbDate): string {
		return date ?
			`${date.year}-${date.month}-${date.day}` :
			null;
	}
}
